__turbopack_context__.v({
  "budgetFooter": "lens-module__pU4mRa__budgetFooter",
  "budgetMore": "lens-module__pU4mRa__budgetMore",
  "card": "lens-module__pU4mRa__card",
  "cardMeta": "lens-module__pU4mRa__cardMeta",
  "cardSpacer": "lens-module__pU4mRa__cardSpacer",
  "cardTitle": "lens-module__pU4mRa__cardTitle",
  "cardTitleRow": "lens-module__pU4mRa__cardTitleRow",
  "count": "lens-module__pU4mRa__count",
  "dot": "lens-module__pU4mRa__dot",
  "empty": "lens-module__pU4mRa__empty",
  "filterRow": "lens-module__pU4mRa__filterRow",
  "headerBar": "lens-module__pU4mRa__headerBar",
  "headerRight": "lens-module__pU4mRa__headerRight",
  "headerTitle": "lens-module__pU4mRa__headerTitle",
  "lane": "lens-module__pU4mRa__lane",
  "laneCards": "lens-module__pU4mRa__laneCards",
  "laneCount": "lens-module__pU4mRa__laneCount",
  "laneHead": "lens-module__pU4mRa__laneHead",
  "laneLabel": "lens-module__pU4mRa__laneLabel",
  "lanes": "lens-module__pU4mRa__lanes",
  "lanesScroller": "lens-module__pU4mRa__lanesScroller",
  "main": "lens-module__pU4mRa__main",
  "mapRegion": "lens-module__pU4mRa__mapRegion",
  "parentPrefix": "lens-module__pU4mRa__parentPrefix",
  "parentSep": "lens-module__pU4mRa__parentSep",
  "standardMark": "lens-module__pU4mRa__standardMark",
  "tombstone": "lens-module__pU4mRa__tombstone",
  "tombstoneActs": "lens-module__pU4mRa__tombstoneActs",
  "tombstoneConfig": "lens-module__pU4mRa__tombstoneConfig",
  "tombstoneLabel": "lens-module__pU4mRa__tombstoneLabel",
  "tombstoneNote": "lens-module__pU4mRa__tombstoneNote",
  "tombstoneQuiet": "lens-module__pU4mRa__tombstoneQuiet",
  "viewCluster": "lens-module__pU4mRa__viewCluster",
});
